module.exports = __webpack_public_path__ + "img/finfinder.f650c8d0.svg";